import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Img from "gatsby-image";
import { rhythm } from "../utils/typography";

class ChangeLogIndex extends React.Component {
  render() {
    const { data } = this.props;
    const siteTitle = data.site.siteMetadata.title;
    const posts = data.allMarkdownRemark.edges;

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Changelog" type={"article"} />
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug;
          const hasImage =
            node.frontmatter.featuredImage &&
            node.frontmatter.featuredImage.childImageSharp.fluid;

          return (
            <div
              className="blog-post-item"
              key={node.fields.slug}
              style={{ marginBottom: rhythm(1), marginTop: rhythm(1) }}
            >
              <div className="content">
                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: rhythm(1 / 4),
                  }}
                >
                  <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                    {title}
                  </Link>
                </h3>
                <small>{node.frontmatter.date}</small>
                <p
                  dangerouslySetInnerHTML={{
                    __html: node.frontmatter.description || node.excerpt,
                  }}
                />
              </div>
              {hasImage && (
                <div className="image" style={{ minWidth: 200 }}>
                  <Img
                    fluid={node.frontmatter.featuredImage.childImageSharp.fluid}
                  />
                </div>
              )}
            </div>
          );
        })}
      </Layout>
    );
  }
}

export default ChangeLogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { type: { eq: "changelog" } } }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 630) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
